exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-input--selection-controls.v-input .v-label[data-v-b2accb20]{margin-right:50px!important}", ""]);

// exports
